import { useEffect,useCallback } from 'react'
import { useFormikContext } from 'formik'
import { useParams } from 'react-router-dom'

import queryClient from 'config/tanstackQuery'

import { Input } from 'components/form/input'
import useTemNewStore from 'store/client/temNewStore'
export default function BrandSizesZaraHome({ idx,tab ,brannd,setifinch,setdepartmantIDD,ifinch}) {
  const { orderNo } = useParams()
  const { values, setFieldValue } = useFormikContext()

  const cacheData = queryClient.getQueryData(['/list', 'sizeGroup'])
  const { anotherValue } = useTemNewStore();



  const getSizeDisplay = useCallback((item, findSizeData,setifinch,setdepartmantIDD,ifinch) => {
    if (item.cm || item.inches) {
      setifinch(true)
      return item.cm || item.inches;
    }
    if (item.europe || item.usa || item.mexico || item['br-brasil']) {
      const isCocuk = findSizeData?.name?.includes('ÇOCUK');
      const isBebek = findSizeData?.name?.includes('BEBEK');
      setifinch(false)
      if (isCocuk || isBebek) {
        return item.size?.split(' ')[0] || item.europe;
      }
      return item.europe || item.usa || item.mexico || item['br-brasil'];
    }
    return item.size || item.scode || '';
  }, [setifinch, setdepartmantIDD]);


  const handleSizeChange = (index, field, value) => {
    const newSizes = [...values.extraHomeCardLabel[idx].sizes]
    newSizes[index] = {
      ...newSizes[index],
      [field]: value,
      ...(field === 'inches' && !newSizes[index].usa && !newSizes[index].mexico && !newSizes[index]['br-brasil'] && {
        usa: value,
        mexico: value,
        'br-brasil': value
      })
    }
    setFieldValue(`extraHomeCardLabel[${idx}].sizes`, newSizes)
  }
  const normalizeMixed = (mixed) => {
    const arr = Array.isArray(mixed) ? mixed.slice(0, 4) : []
    for (let i = 0; i < 4; i += 1) {
      if (!arr[i]) {
        arr[i] = { currency: '', currencyType: undefined }
      } else {
        arr[i] = {
          currency: String(arr[i].currency || ''),
          currencyType: arr[i].currencyType || undefined,
        }
      }
    }
    return arr
  }
  useEffect(() => {
    const updateSizes = () => {
      if (!cacheData) return;
      const findSizeData = cacheData.find(item => item.id === values.sizeGroup);
      if (!findSizeData) return;
      setdepartmantIDD(findSizeData.id);

      const newSizes = findSizeData.sizes.map((item, idx2) => {
        const sizeDisplay = getSizeDisplay(item, findSizeData, setifinch, setdepartmantIDD, ifinch);

        const base = {
          name: item.scode,
          amount: '',
          amountWithDefect: '',
          cn: item.cnupperwoman || item.cm || '',
          sCode: item.scode || '',
          uid: item.uid,
          description: '',
          // Initialize empty arrays and objects for new sizes
          additionalPhrases: [],
          washingAdditionalPhrases: [],
          symbol: {},
          fabric: [],
          pack: ''
        };

        const dynamicSizeFields = Object.keys(item).reduce((acc, key) => {
          if (
            ['scode','amount','amountWithDefect','name'].includes(key) ||
            typeof item[key] !== 'string'
          ) return acc;

          acc[key] = item[key] || '';
          return acc;
        }, {});

        return { ...base, ...dynamicSizeFields };
      });

      setFieldValue(`extraHomeCardLabel[${idx}].sizes`, newSizes);
    };

    const updateSizes2 = () => {
      if (!cacheData) return;
      const findSizeData = cacheData.find(item => item.id === values.sizeGroup);
      if (!findSizeData) return;
      setdepartmantIDD(findSizeData.id);

      const newSizes = findSizeData.sizes.map((item, idx2) => {
        const sizeDisplay = getSizeDisplay(item, findSizeData, setifinch, setdepartmantIDD, ifinch);

        const prev = values.extraHomeCardLabel[idx]?.sizes[idx2] || {};
        const base = {
          name: item.scode,
          amount: prev.amount || '',
          amountWithDefect: prev.amountWithDefect || '',
          sCode: item.scode || '',
          description: prev.description || '',
          uid: item.uid,
          mixed: normalizeMixed(prev.mixed),
          // Preserve existing data
          additionalPhrases: prev.additionalPhrases || [],
          washingAdditionalPhrases: prev.washingAdditionalPhrases || [],
          symbol: prev.symbol || {},
          fabric: prev.fabric || [],
          pack: prev.pack || ''
        };

        const dynamicSizeFields = Object.keys(item).reduce((acc, key) => {
          if (
            ['scode','amount','amountWithDefect','name'].includes(key) ||
            typeof item[key] !== 'string'
          ) return acc;

          acc[key] = item[key] || '';
          return acc;
        }, {});

        return { ...base, ...dynamicSizeFields };
      });

      setFieldValue(`extraHomeCardLabel[${idx}].sizes`, newSizes);
    };

    if (!orderNo || (orderNo && values.extraHomeCardLabel[idx]?.sizes?.length === 0)) {
      updateSizes();
    } else {
      updateSizes2();
    }
  }, [cacheData, orderNo, anotherValue, values.sizeGroup, idx, setFieldValue, getSizeDisplay]);



  const totalAmount = values.extraHomeCardLabel[idx].sizes?.reduce((acc, curr) => {
    if (curr.amount) return acc + parseInt(curr.amount)
    return acc
  }, 0)

  const totalAmountWithDefect = values.extraHomeCardLabel[idx].sizes?.reduce((acc, curr) => {
    const amount = curr.amountWithDefect
    if (amount.length > 1) return acc + parseInt(amount)
    return acc
  }, 0)

  return (
    <div className="rounded border border-dashed p-2">
      <div className="mb-2 grid grid-cols-4 gap-x-5 text-sm font-medium text-simsek">
        <p>Beden</p>
        <p>Adet</p>
        <p>%</p>
        <p>Fireli Adet</p>
      </div>
      <div className="space-y-1">
        {values.extraHomeCardLabel[idx].sizes.length < 1 ? (
          <div className="bg-rose-400 rounded p-2 text-center my-4">
            <p className="text-white text-sm">Lütfen beden tablosu seçiniz!</p>
          </div>
        ) : (
          values.extraHomeCardLabel[idx].sizes.map((_, index) => {
            const amount = values.extraHomeCardLabel[idx].sizes[index]?.amount
            const percent =
              (values.extraHomeCardLabel[idx].sizes[index]?.amount *
                values.extraHomeCardLabel[idx].sizeDefectivePercent) /
                100 || 0
            const wastageQuantity = String(parseInt(amount) + parseInt(percent))
            return (
              <div className="grid grid-cols-4 gap-x-5" key={index}>
                <Input
                  name={`extraHomeCardLabel[${idx}].sizes[${index}].name`}
                  disabled
                  autoComplete="off"
                />
                <Input
                  name={`extraHomeCardLabel[${idx}].sizes[${index}].amount`}
                  onWheel={(e) => e.target.blur()}
                  autoComplete="off"
                />

                <Input name={`extraHomeCardLabel[${idx}].sizeDefectivePercent`} autoComplete="off"
                  type="number"
                  min={0}
                  max={20}
                  step={1}
                  inputMode="numeric"
                  onWheel={(e) => e.target.blur()}
                  onChange={(e) => {
                    const digitsOnly = String(e.target.value).replace(/\D/g, '')
                    if (digitsOnly === '') {
                      setFieldValue(`extraHomeCardLabel[${idx}].sizeDefectivePercent`, '')
                      return
                    }
                    let n = parseInt(digitsOnly, 10)
                    if (Number.isNaN(n)) return
                    n = Math.min(20, Math.max(0, n))
                    setFieldValue(`extraHomeCardLabel[${idx}].sizeDefectivePercent`, n)
                  }}
                />

                <Input
                  name={`extraHomeCardLabel[${idx}].sizes[${index}].amountWithDefect`}
                  autoComplete="off"
                  value={
                    values.extraHomeCardLabel[idx].sizes[index].amount.length === 0
                      ? ' '
                      : wastageQuantity
                  }
                  disabled
                />
              </div>
            )
          })
        )}
        {values.extraHomeCardLabel[idx].sizes.length > 0 && (
          <div className="grid grid-cols-4 gap-x-10">
            <p></p>
            <p className="text-sm font-semibold text-center">{totalAmount}</p>
            <p></p>
            <p className="text-sm font-semibold text-center">{totalAmountWithDefect}</p>
          </div>
        )}
      </div>
    </div>
  )
}
